import {Component, Input, OnInit} from '@angular/core';
import {ContactDetailsResponse, ContactType} from '@npck/af-frontend-api';

const TYPES_WITHOUT_MSISDN: string[] = [
    ContactType.PERSONAL_COMMUNICATION,
    ContactType.INTERNET,
    ContactType.SOCIAL,
    ContactType.EMAIL,
];

@Component({
    selector: 'af-incident-contact',
    templateUrl: 'incident-contact.component.html',
    styleUrl: 'incident-contact.component.scss',
    standalone: false,
})
export class IncidentContactComponent implements OnInit {
    @Input() contactDetails: ContactDetailsResponse;
    @Input() allowedTabs?: ContactDetailTab[];
    tabs: ContactDetailTab[] = [];
    selectedTabIndex: number;

    ngOnInit(): void {
        const defaultTabs: ContactDetailTab[] = TYPES_WITHOUT_MSISDN.includes(this.contactDetails.contactType)
            ? ['tabContactDetails', 'tabFiles']
            : ['tabContactDetails', 'tabMsisdnInfo', 'tabStatusHistory', 'tabFiles'];
        this.tabs = this.allowedTabs
            ? defaultTabs.filter(t => this.allowedTabs.includes(t))
            : defaultTabs;
    }
}

export type ContactDetailTab = 'tabContactDetails' | 'tabMsisdnInfo' | 'tabStatusHistory' | 'tabFiles';
